import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

import { validUrlValidator } from './valid-url.validator';

export const relevantInputValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  const tab = control.get('tab')!;
  const url = control.get('url')!;
  const spreadsheetId = control.get('spreadsheetId')!;
  const worksheetId = control.get('worksheetId')!;
  /* eslint-enable @typescript-eslint/no-non-null-assertion */

  const errors: { sheetSelection?: true; invalidName?: true; invalidUrl?: true } = {};

  if (tab?.value === 'Search') {
    if (Validators.required(spreadsheetId) || Validators.required(worksheetId)) {
      errors.sheetSelection = true;
    }
  }

  if (tab?.value === 'By URL') {
    if (Validators.required(url) || validUrlValidator(url)) {
      errors.invalidUrl = true;
    }
  }

  return Object.keys(errors).length ? errors : null;
};
